// extracted by mini-css-extract-plugin
export default {"info":"contact-form_info__aXfZd","tooltip":"contact-form_tooltip__h7iYL","files_formats":"contact-form_files_formats__84k8w"};